import React from "react";
import Header from "../../sections/Header/Header";
import Main from "../../sections/Main/Main";
import Footer from "../../sections/Footer/Footer";

const Index: React.FC = () => {
    return (
        <div className="wrapper">
            <Header />
            <Main />
            <Footer />
        </div>
    );
}

export default Index;